import { render, staticRenderFns } from "./ClassView.vue?vue&type=template&id=1048f84e&scoped=true&"
import script from "./ClassView.vue?vue&type=script&lang=js&"
export * from "./ClassView.vue?vue&type=script&lang=js&"
import style0 from "./ClassView.vue?vue&type=style&index=0&id=1048f84e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1048f84e",
  null
  
)

export default component.exports